module.exports = __webpack_public_path__ + "static/media/phone-handset-line.a4f3ef96.svg";